import React from "react";
import { Button } from "@/components/ui/button";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

export default function Pagination({ page, limit, total, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  if (totalPages <= 1) return null;

  const pages = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, page + 2);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div data-testid="pagination" className="flex items-center justify-between pt-4">
      <p className="text-xs text-slate-500">
        Menampilkan {(page - 1) * limit + 1}-{Math.min(page * limit, total)} dari {total}
      </p>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid="pagination-prev"
          className="h-8 w-8 p-0"
        >
          <CaretLeft size={14} />
        </Button>
        {pages.map((p) => (
          <Button
            key={p}
            variant={p === page ? "default" : "outline"}
            size="sm"
            onClick={() => onPageChange(p)}
            data-testid={`pagination-page-${p}`}
            className={`h-8 w-8 p-0 text-xs ${p === page ? "bg-[#B8860B] text-white" : ""}`}
          >
            {p}
          </Button>
        ))}
        <Button
          variant="outline"
          size="sm"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          data-testid="pagination-next"
          className="h-8 w-8 p-0"
        >
          <CaretRight size={14} />
        </Button>
      </div>
    </div>
  );
}
